/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Mastercard: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <rect width='32' height='32' rx='16' fill='black' />
    <path d='M18.8126 21.0325H13.1868V10.9692H18.8126V21.0325Z' fill='#FF5F00' />
    <path
      d='M13.5473 16.0001C13.5473 13.9588 14.5075 12.1404 16.0029 10.9685C14.9094 10.1116 13.5293 9.60015 12.0294 9.60015C8.47849 9.60015 5.6001 12.4655 5.6001 16.0001C5.6001 19.5348 8.47849 22.4001 12.0294 22.4001C13.5293 22.4001 14.9094 21.8887 16.0029 21.0318C14.5075 19.8599 13.5473 18.0415 13.5473 16.0001Z'
      fill='#EB001B'
    />
    <path
      d='M26.4001 16.0001C26.4001 19.5348 23.5217 22.4001 19.9708 22.4001C18.4709 22.4001 17.0908 21.8887 15.9968 21.0318C17.4926 19.8599 18.4529 18.0415 18.4529 16.0001C18.4529 13.9588 17.4926 12.1404 15.9968 10.9685C17.0908 10.1116 18.4709 9.60015 19.9708 9.60015C23.5217 9.60015 26.4001 12.4655 26.4001 16.0001Z'
      fill='#F79E1B'
    />
  </React.Fragment>
)
